import { registerSW } from 'virtual:pwa-register'

// One hour. A standalone (installed) session can stay open for days without a
// full page load, so we poll for a new service worker instead of relying on
// navigation alone. `registerType: 'autoUpdate'` then swaps it in and reloads.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000

export function registerServiceWorker(): void {
  registerSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return
      setInterval(() => {
        void registration.update()
      }, UPDATE_CHECK_INTERVAL_MS)
    },
    onRegisterError(error) {
      console.error('Service worker registration failed', error)
    },
  })
}
